// extracted by mini-css-extract-plugin
export default {"afterpayBtnWrapper":"V4-z","button":"W4-z","disabled":"X4-z","creditCard":"Y4-z","wrapper":"Z4-z"};